module.exports = __webpack_public_path__ + "static/media/music2.ef25f082.jpg";